<template>
  <v-btn-secondary
    v-tooltip="{ text: statusText, openDelay: 500 }"
    size="small"
    :loading="isInitialLoading"
    @click="showDialog = true"
  >
    <template #prepend>
      <LiveStatusIcon :status="overallStatus" />
    </template>
    {{ t('live_status.button') }}
  </v-btn-secondary>
  <LiveStatusDialog v-model="showDialog" />
</template>

<script setup lang="ts">
import { SERVICE_STATUSES } from '@deepcloud/service-status'
import { useLiveStatus } from '@/composables/use-live-status'
import LiveStatusDialog from './LiveStatusDialog.vue'
import LiveStatusIcon from './LiveStatusIcon.vue'

const { t } = useI18n()
const { isInitialLoading, overallStatus } = useLiveStatus()

const showDialog = ref(false)

const statusText = computed(() => {
  switch (overallStatus.value) {
    case SERVICE_STATUSES.UP:
      return t('live_status.all_ok')
    case SERVICE_STATUSES.DOWN:
      return t('live_status.issue')
    case SERVICE_STATUSES.UNREACHABLE:
      return t('live_status.unreachable')
    default:
      return t('live_status.loading')
  }
})
</script>
